<template>
  <div class="text-center" elevation="0">
    <v-row>
      <v-col>
        <EmailSignIn />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <GoogleSignIn />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <FacebookSignIn />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AppleSignIn />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols=12>
        <i18n path="password.forgotYourPassword?">
          <template #link>
            <router-link to="/auth/forgot-password">{{$t('password.forgotYourPassword?Link')}}</router-link>
          </template>
        </i18n>
      </v-col>
    </v-row>
    <v-row align="center" class="mt-10" no-gutters>
      <v-col><div class="or-hr-side" /></v-col>
      <v-col class="or-hr-text text-uppercase px-2" cols="auto"
        ><span>{{ $t("login.or") }}</span></v-col
      >
      <v-col><div class="or-hr-side" /></v-col>
    </v-row>
    <v-row>
      <v-sheet>
        <i18n path="login.youAgree">
          <a href="https://about.storycity.app/terms-of-use/" target="_blank">{{
            $t("login.youAgree0")
          }}</a>
          <a href="https://about.storycity.app/privacy-policy/" target="_blank">{{
            $t("login.youAgree1")
          }}</a>
        </i18n>
      </v-sheet>
    </v-row>
    <v-row class="my-9">
      <v-btn to="/auth/register" block color="primary">{{
        $t("register.signUpWithEmail")
      }}</v-btn>
    </v-row>
    <v-row>
      <v-col cols=6>
        <GooglePlayLink />
      </v-col>
      <v-col cols=6> 
        <IosStoreLink />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import EmailSignIn from "@/components/Auth/EmailSignIn.vue";
import GoogleSignIn from "@/components/Auth/GoogleSignIn.vue";
import { MAX_PASSWORD_LENGTH } from "@/const";
import GooglePlayLink from "@/components/GooglePlayLink"
import IosStoreLink from "@/components/IosStoreLink"
import logout from '@/logout'
export default {
  components: {
    FacebookSignIn: () => import("@/components/Auth/FacebookSignIn.vue"),
    AppleSignIn: () => import("@/components/Auth/AppleSignIn.vue"),
    GooglePlayLink,
    GoogleSignIn,
    IosStoreLink,
    EmailSignIn,
  },
  computed: {
    ...mapGetters("auth/login", [
      "getInProgress",
      "getSuccess",
      "getErrorMessages",
    ]),
    userId() {
      return this.$root.userId;
    },
    errors() {
      let errorText = "";
      if (this.getErrorMessages.length == 0) {
        return null;
      } else {
        for (const error of this.getErrorMessages) {
          errorText += error;
        }
      }
      return errorText;
    },
  },
  created() {
    this.MAX_PASSWORD_LENGTH = MAX_PASSWORD_LENGTH;
  },
  methods: {
    ...mapMutations("auth", ["setMe"]),
    loginAction() {
      this.logIn({ username: this.username, password: this.password, redirect: this.$route.query.redirect });
    },
    ...mapActions("auth/login", ["logIn"]),
    logout() {
      logout()
    },
  },
  watch: {
    getSuccess(newValue) {
      if (newValue == true) {
        this.username = "";
        this.password = "";
      }
    },
  },
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      rules: {
        required: (value) => !!value || this.$t("forms.thisFieldIsRequired"),
      },
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep .login-input-text fieldset {
  border: 2px solid;
  border-radius: 16px;
}
.or-hr-side {
  border: 2px solid var(--v-accentElement-base);
  border-radius: 2px;
}
.or-hr-text {
  font-size: 1.5em;
}
::v-deep h1 {
  font-size: 1.3em;
  text-align: left;
}
</style>
